import biLogger from '@wix/web-bi-logger';
import { BI_SOURCE } from '../constants';
import { getQueryParam, getTime } from './window-utils';

export class BiLogger {
  private logger: any;
  private msid: string = '';
  private origin: string = '';
  private referralInfo: string = '';
  private platform: string = '';
  private startTimeInMainPage: number = 0;
  private startTimeInSecondPage: number = 0;
  private firstTimeScroll: boolean = false;

  init = (isMobile = false) => {
    const urlParams = getQueryParam();
    this.msid =
      urlParams.get('metaSiteId') || urlParams.get('__metaSiteId') || '';
    this.origin = urlParams.get('originAppSlug') || 'EmptySlug';
    this.referralInfo = urlParams.get('pp_origin') || 'EmptyPPOrigin';
    this.startTimeInMainPage = getTime();
    this.platform = isMobile ? 'native' : 'web';

    const { msid, origin, referralInfo, platform } = this;
    const app_id: string = 'ee21fe60-48c5-45e9-95f4-6ca8f9b1c9d9';

    this.logger = biLogger
      .factory({ endpoint: 'dash' })
      .updateDefaults({
        src: BI_SOURCE,
        msid,
        referralInfo,
        origin,
        app_id,
        platform,
      })
      .logger();
  };

  ppOpen = () => {
    return this.logger.log({ evid: 131, num_of_packages: 3 });
  };

  buttonClicked = (params: { msid: string; button_name: string }) => {
    return this.logger.log({ evid: 190, ...params });
  };

  showMoreLess = (params: {
    action: string;
    productName: string;
    ascend_product?: string;
  }) => {
    return this.logger.log({ evid: 132, ...params });
  };

  fistTimeScrollToEndTable = () => {
    if (this.firstTimeScroll) {
      return;
    }
    const currentTime = getTime();
    const timeInPage = currentTime - this.startTimeInMainPage;
    this.firstTimeScroll = true;
    return this.logger.log({ evid: 133, timeInPage });
  };

  ppSelected = (params: {
    buttonType: string;
    package_name: string;
    packageId: string;
    isChecked: boolean;
  }) => {
    const currentTime = getTime();
    const timeInPage = currentTime - this.startTimeInMainPage;
    return this.logger.log({ evid: 134, timeInPage, ...params });
  };

  cycleOpen = (params: { packageId: string; package_name: string }) => {
    this.startTimeInSecondPage = getTime();
    return this.logger.log({ evid: 135, ...params });
  };

  cycleClick = (params: {
    cycleName: string;
    cycleId: string;
    packageId: string;
    package_name: string;
  }) => {
    return this.logger.log({ evid: 136, ...params });
  };

  cycleSelected = (params: {
    cycleName: string;
    cycleId: string;
    isChecked: boolean;
    packageId: string;
    package_name: string;
  }) => {
    const currentTime = getTime();
    const timeInPage = currentTime - this.startTimeInSecondPage;
    return this.logger.log({ evid: 137, ...params, timeInPage });
  };

  thanksPageOpen = (params: {
    cycle_name: string;
    cycleId: string;
    packageId: string;
    package_name: string;
  }) => {
    return this.logger.log({ evid: 191, type: 'page view', ...params });
  };

  thanksButtonClick = (params: {
    cycle_name: string;
    cycleId: string;
    packageId: string;
    package_name: string;
  }) => {
    return this.logger.log({
      evid: 191,
      type: 'click go to dashboard',
      ...params,
    });
  };
}
